import { Component, inject, Injector } from '@angular/core';
import { CommandsService, ICommandTemplateUpdateModel } from "../../../../services/commands.service";
import { CommandDialogBaseComponent } from "../command-dialog-base/command-dialog-base.component";

@Component({
    selector: 'app-edit-command',
    templateUrl: '../command-dialog-base/command-dialog-base.component.html',
    styleUrls: ['../command-dialog-base/command-dialog-base.component.css'],
    standalone: false
})
export class EditCommandComponent extends CommandDialogBaseComponent<ICommandTemplateUpdateModel> {
  private service: CommandsService = inject(CommandsService);

  constructor(protected injector: Injector) {
    super(injector);
    this.dialogId = "editCommand";
  }

  public submit() {
    this.service.update(this.model)
      .subscribe((res) => {
        this.onCreated.emit();
        this.close();
        this.syncService.NotifyEntityChanged("Command", this.model.Id);
        super.submit();
      });
  }
}
